// Shared between DeviceService (SSR-time render) and server.ts (SSR response cache key) so the
// two can never classify the same request differently — if they drift, the cache would serve a
// desktop-rendered page to a mobile UA (or vice versa) whenever a URL is already cached.
export const MOBILE_UA_REGEX = /iPhone|iPod|Android.*Mobile|Windows Phone|BlackBerry|IEMobile|Opera Mini/i;
export const TABLET_UA_REGEX = /iPad|Android(?!.*Mobile)/i;

export function classifyUserAgent(ua: string): 'mobile' | 'tablet' | 'desktop' {
  if (TABLET_UA_REGEX.test(ua)) {
    return 'tablet';
  }
  if (MOBILE_UA_REGEX.test(ua)) {
    return 'mobile';
  }
  return 'desktop';
}
